export const INITIATE_PAYMENT = "INITIATE_PAYMENT";
export const PAYMENT_CHECK_STATUS = "PAYMENT_CHECK_STATUS";